import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss']
})
export class BodyComponent implements OnInit {

  contar: number = 0;

  client = 0;
  Repar = 0;
  touch = 0;

  constructor() { }

  ngOnInit() {

  }


  whatSend() {
    let url: string = "http://wa.me/+5521966057034?text=" + "Olá, vim pelo site da LabPhoneRJ!";

    window.open(url, '_blank').focus();
  }

}

